import { create } from 'zustand';

interface AuthState {
  idToken: string | null;
  setIdToken: (token: string | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  idToken: localStorage.getItem('idToken'),
  setIdToken: (token) => {
    if (token) {
      localStorage.setItem('idToken', token);
    } else {
      localStorage.removeItem('idToken');
    }
    set({ idToken: token });
  },
}));
